module.exports = __webpack_public_path__ + "img/tongue-device.69c9e71a.png";